module.exports = __webpack_public_path__ + "static/videos/etch_001.37cdc51.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/etching/etch_001.mp4
// module id = 463
// module chunks = 1